import type { IntlKey } from 'locales';
import { range } from 'lodash-es';
import { FC, PropsWithChildren } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

import { SeeMorePublicationsListSkeleton } from './see-more-publications-list-skeleton';

export const SeeMorePublicationsCategoriesSkeleton: FC<{ categoryCount: number }> = ({ categoryCount }) => (
  <ListGroup as="div">
    {range(0, categoryCount).map(key => (
      <ListGroupItem as="span" key={key} action active={key === 0}>
        <Skeleton width="8em" />
      </ListGroupItem>
    ))}
  </ListGroup>
);

export const SeeMorePublicationsSkeleton: FC<
  PropsWithChildren<{
    titleKey: IntlKey;
    categoryCount: number;
    itemsCount: number;
  }>
> = ({ titleKey, categoryCount, itemsCount }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="container">
      <div className="row">
        <div className="col-3 border-end px-0">
          <h3 className="ms-4 mt-4 mb-3">{formatMessage({ id: titleKey })}</h3>
          <SeeMorePublicationsCategoriesSkeleton categoryCount={categoryCount} />
        </div>
        <div className="col-9 d-flex flex-column px-0">
          <SeeMorePublicationsListSkeleton itemsCount={itemsCount} />
        </div>
      </div>
    </div>
  );
};
